/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import styles from "../../../../styles/scope3/Dashboard/purchaseGoods.module.css";
import { durationObj, monthSort } from "../../../../utils/constant";
import BarChart from "../../../../Components/GraphNCharts/BarChart";
import TableChart from "../../../../Components/GraphNCharts/TableChart";
import GlobalChart from "../../../../Components/GraphNCharts/GlobalChart";
import { get } from "../../../../utils/api";
import {
  generateBarChartDataSetForWaste,
  manipulateDataForBarChart,
} from "../../../../utils/graphFunctions";
import PeriodFilter from "../../../../Components/Common/PeriodFilter";
import TableChartAmount from "../../../../Components/GraphNCharts/TableChartAmount";
import {
  fixedPercentage,
  fixedTons,
  formatNumberCommaSeparated,
  truncateNumber,
} from "../../../../utils/common";
import NoDataFound from "../../../../Components/Masters/NoDataFound";
import { Box } from "@mui/material";
import useAuthStore from "../../../../store/ContextUser";

const Dashboard = () => {
  const currentDate = new Date();
  const {selectedCompany} = useAuthStore();
  const currentYear = currentDate.getFullYear();

  const [fromDate, setFromDate] = useState({
    month: 1,
    year: currentYear,
  });
  const [toDate, setToDate] = useState({
    month: currentDate.getMonth() + 1,
    year: currentYear,
  });
  const [month, setMonth] = useState("1M");
  const [countryEmissionMonth, setCountryEmissionMonth] = useState("1M");
  const [year, setYear] = useState("");

  const [dashboardData, setDashboardData] = useState({
    totalAmount: null,
    emissionActivity: null,
    vendorEmission: null,
    facilitySpend: null,
    spendAnalysisAmount: null,
    spendAnalysisActivity: null,
    spendAnalysisVendor: null,
    spendAnalysisFacility: null,
    activityAnalysis: null,
    top3Vendor: null,
    comparativeSpending: null,
    facilitySpecific: null,
    top3Facility: null,
    topPurchasedGoods: null,
    // vendorSpecificSpendEmission: null,
    facilitySpecificData: null,
    facilitySpendEmission: null,
    vendorSpendEmission: null,
  });

  const [vendorList, setVendors] = useState([]);
  const [facilityList, setFacilities] = useState([]);
  const [tableData, setTableData] = useState();
  const [amountSpent, setAmountSpent] = useState();
  const [activitySpend, setActivitySpend] = useState(null);
  const [activityPercetage, setActivityPercentage] = useState(null);
  const [error, setError] = useState(null);

  const [selectedFacility, setSelectedFacility] = useState([]);

  const [graphView, setGraphView] = useState({
    topVendor: "Spending",
    facilityType: "Spending",
    vendorName: "",
    facilityName: "",
    yearData: currentYear,
    activityName: "Purchase of Goods",
  });

  const generateYearList = (startYear = 2020) => {
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let year = startYear; year <= currentYear; year++) {
      years.push(year);
    }
    return years;
  };
  const yearList = generateYearList(2020);

  const fetchGlobalData = async () => {
    try {
      let response = await get(
        `dashboard/globalEmission/purchaseGoodsServicesMap?timeFrame=${month}&companyId=${selectedCompany?._id}`
      );
      setTableData(response?.data?.data);
    } catch (error) {}
  };

  const fetchCountryEmissionData = async () => {
    try {
      const response = await get(
        `dashboard/globalEmission/countryEmission?timeFrame=${countryEmissionMonth}&companyId=${selectedCompany?._id}`
      );
      setAmountSpent(
        response?.data?.data ??
          response?.data?.amountSpent ??
          response?.data
      );
    } catch (error) {}
  };

  useEffect(() => {
    fetchGlobalData();
  }, [month, selectedCompany]);

  useEffect(() => {
    fetchCountryEmissionData();
  }, [countryEmissionMonth, selectedCompany]);

  const apiUrls = {
    totalAmount: `/dashboard/scope3/purchasegoods/totalAmountSpent?startYear=${
      fromDate.year
    }&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${
      toDate.month
    }&facilities=${selectedFacility.join(",")}&companyId=${selectedCompany?._id}`,
    emissionActivity: `/dashboard/scope3/purchasegoods/emissionByTypeOfAcitvity?startYear=${
      fromDate.year
    }&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${
      toDate.month
    }&facilities=${selectedFacility.join(",")}&companyId=${selectedCompany?._id}`,
    vendorEmission: `/dashboard/scope3/purchasegoods/emissionByVendor?vendorName=${encodeURIComponent(
      graphView.vendorName
    )}startYear=${fromDate.year}&startMonth=${fromDate.month}&endYear=${
      toDate.year
    }&endMonth=${toDate.month}&facilities=${selectedFacility.join(",")}&companyId=${selectedCompany?._id}`,
    facilitySpend: `/dashboard/scope3/purchasegoods/amountSpendByFacility?startYear=${
      fromDate.year
    }&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${
      toDate.month
    }&facilities=${selectedFacility.join(",")}&companyId=${selectedCompany?._id}`,
    spendAnalysisAmount: `/dashboard/scope3/purchasegoods/spendingAnalysisAmount?startYear=${
      fromDate.year
    }&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${
      toDate.month
    }&facilities=${selectedFacility.join(",")}&companyId=${selectedCompany?._id}`,
    spendAnalysisActivity: `/dashboard/scope3/purchasegoods/spendingAnalysisVariousAcitivity?startYear=${
      fromDate.year
    }&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${
      toDate.month
    }&facilities=${selectedFacility.join(",")}&companyId=${selectedCompany?._id}`,
    spendAnalysisVendor: `/dashboard/scope3/purchasegoods/spendingAnalysisByvendor?startYear=${
      fromDate.year
    }&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${
      toDate.month
    }&facilities=${selectedFacility.join(",")}&companyId=${selectedCompany?._id}`,
    spendAnalysisFacility: `/dashboard/scope3/purchasegoods/spendingAnalysisByFacility?startYear=${
      fromDate.year
    }&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${
      toDate.month
    }&facilities=${selectedFacility.join(",")}&companyId=${selectedCompany?._id}`,
    activityAnalysis: `/dashboard/scope3/purchasegoods/activitySpecificAnalysis?startYear=${
      fromDate.year
    }&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${
      toDate.month
    }&facilities=${selectedFacility.join(",")}&companyId=${selectedCompany?._id}`,
    top3Vendor: `/dashboard/scope3/purchasegoods/top3VendorAnalysis?startYear=${
      fromDate.year
    }&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${
      toDate.month
    }&facilities=${selectedFacility.join(",")}&companyId=${selectedCompany?._id}`,
    comparativeSpending: `/dashboard/scope3/purchasegoods/comparativeSpendingEmissionVendor?startYear=${
      fromDate.year
    }&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${
      toDate.month
    }&facilities=${selectedFacility.join(",")}&companyId=${selectedCompany?._id}`,
    facilitySpecific: `/dashboard/scope3/purchasegoods/facilitySpecificAnalysis?startYear=${
      fromDate.year
    }&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${
      toDate.month
    }&facilities=${selectedFacility.join(",")}&companyId=${selectedCompany?._id}`,
    top3Facility: `/dashboard/scope3/purchasegoods/top3FacilityAnalysis?startYear=${
      fromDate.year
    }&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${
      toDate.month
    }&facilities=${selectedFacility.join(",")}&companyId=${selectedCompany?._id}`,
    topPurchasedGoods: `/dashboard/scope3/purchasegoods/topPurchasedGoodAndService?year=${
      graphView?.yearData
    }&facilities=${selectedFacility.join(",")}&companyId=${selectedCompany?._id}`,
    //   graphView.vendorName
    // )}`,
    facilitySpendEmission: `/dashboard/scope3/purchasegoods/facility/spendEmission?startYear=${
      fromDate.year
    }&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${
      toDate.month
    }&facilities=${selectedFacility.join(",")}&companyId=${selectedCompany?._id}`,
  };

  const fetchData = async () => {
    try {
      const apiCalls = [
        { key: "totalAmount", url: apiUrls.totalAmount },
        { key: "emissionActivity", url: apiUrls.emissionActivity },
        { key: "facilitySpend", url: apiUrls.facilitySpend },
        { key: "spendAnalysisAmount", url: apiUrls.spendAnalysisAmount },
        { key: "spendAnalysisActivity", url: apiUrls.spendAnalysisActivity },
        { key: "spendAnalysisFacility", url: apiUrls.spendAnalysisFacility },
        { key: "activityAnalysis", url: apiUrls.activityAnalysis },
        { key: "top3Vendor", url: apiUrls.top3Vendor },
        { key: "comparativeSpending", url: apiUrls.comparativeSpending },
        { key: "facilitySpecific", url: apiUrls.facilitySpecific },
        { key: "top3Facility", url: apiUrls.top3Facility },
        { key: "facilitySpendEmission", url: apiUrls.facilitySpendEmission },
      ];

      const results = await Promise.allSettled(
        apiCalls.map(({ url }) => get(url))
      );

      const dashboardUpdates = {};
      results.forEach((result, index) => {
        const { key } = apiCalls[index];
        if (result.status === "fulfilled") {
          dashboardUpdates[key] = result.value.data;
        } else {
          console.error(`Error fetching ${key}:`, result.reason.message);
        }
      });

      setDashboardData((prev) => ({
        ...prev,
        ...dashboardUpdates,
      }));
    } catch (err) {
      setError("Error fetching data: " + err.message);
    } finally {
    }
  };

  console.log(dashboardData, "dash1");

  const vendorEmissionData = async () => {
    try {
      if (graphView.vendorName === "") {
        return;
      }
      const response = await get(
        `/dashboard/scope3/purchasegoods/emissionByVendor?vendorName=${encodeURIComponent(
          graphView.vendorName
        )}&startYear=${fromDate.year}&startMonth=${fromDate.month}&endYear=${
          toDate.year
        }&endMonth=${toDate.month}&facilities=${selectedFacility.join(",")}&companyId=${selectedCompany?._id}`
      );
      setDashboardData((prev) => ({
        ...prev,
        vendorEmission: response.data,
      }));
    } catch (err) {
      setError("Error fetching data: " + err.message);
    }
  };

  useEffect(() => {
    vendorEmissionData();
  }, [graphView?.vendorName, fromDate, toDate, selectedFacility,selectedCompany]);

  const vendorEmissionSpendData = async () => {
    try {
      if (graphView.vendorName === "") {
        return;
      }
      const response = await get(
        `/dashboard/scope3/purchasegoods/vendor/spendEmission?vendorName=${encodeURIComponent(
          graphView.vendorName
        )}&startYear=${fromDate.year}&startMonth=${fromDate.month}&endYear=${
          toDate.year
        }&endMonth=${toDate.month}&facilities=${selectedFacility.join(",")}&companyId=${selectedCompany?._id}`
      );
      setDashboardData((prev) => ({
        ...prev,
        vendorSpendEmission: response.data,
      }));
    } catch (err) {
      setError("Error fetching data: " + err.message);
    }
  };

  useEffect(() => {
    vendorEmissionSpendData();
  }, [graphView?.vendorName,selectedCompany]);

  const facilityEmissionData = async () => {
    try {
      if (graphView.vendorName === "") {
        return;
      }
      const response = await get(
        `/dashboard/scope3/purchasegoods/facilitySpendingEmission?facilityName=${
          graphView?.facilityName
        }startYear=${fromDate.year}&startMonth=${fromDate.month}&endYear=${
          toDate.year
        }&endMonth=${toDate.month}&facilities=${selectedFacility.join(",")}`
      );
      setDashboardData((prev) => ({
        ...prev,
        facilitySpecificData: response.data,
      }));
    } catch (err) {
      setError("Error fetching data: " + err.message);
    }
  };

  useEffect(() => {
    facilityEmissionData();
  }, [graphView?.vendorName,selectedCompany]);

  const vendorSpentData = async () => {
    try {
      const response = await get(
        `/dashboard/scope3/purchasegoods/spendingAnalysisByvendor?vendorName=${encodeURIComponent(
          graphView.vendorName
        )}&startYear=${fromDate.year}&startMonth=${fromDate.month}&endYear=${
          toDate.year
        }&endMonth=${toDate.month}&facilities=${selectedFacility.join(",")}&companyId=${selectedCompany?._id}`
      );
      setDashboardData((prev) => ({
        ...prev,
        spendAnalysisVendor: response.data,
      }));
    } catch (err) {
      setError("Error fetching data: " + err.message);
    }
  };

  useEffect(() => {
    vendorSpentData();
  }, [graphView?.vendorName, fromDate, toDate, selectedFacility,selectedCompany]);

  useEffect(() => {
    if (vendorList.length > 0) {
      setGraphView({
        ...graphView,
        vendorName: vendorList[0],
      });
    }
  }, [vendorList,selectedCompany]);

  useEffect(() => {
    if (facilityList.length > 0) {
      setGraphView({
        ...graphView,
        facilityName: facilityList[0],
      });
    }
  }, [facilityList,selectedCompany]);

  useEffect(() => {
    fetchData();
  }, [fromDate, toDate, selectedFacility,selectedCompany]);

  // useEffect(() => {
  //   if (graphView.vendorName) {
  //     get(apiUrls.vendorSpecificSpendEmission)
  //       .then((res) => {
  //         setDashboardData((prev) => ({
  //           ...prev,
  //           vendorSpecificSpendEmission: res.data,
  //         }));
  //       })
  //       .catch((err) => {
  //         setError("Error fetching data: " + err.message);
  //       });
  //   }
  // }, [graphView.vendorName]);

  useEffect(() => {
    if (graphView.yearData) {
      get(apiUrls.topPurchasedGoods)
        .then((res) => {
          setDashboardData((prev) => ({
            ...prev,
            topPurchasedGoods: res.data,
          }));
        })
        .catch((err) => {
          setError("Error fetching data: " + err.message);
          console.log(err);
        });
    }
  }, [graphView.yearData,selectedCompany]);

  useEffect(() => {
    let data = dashboardData?.activityAnalysis?.spendingMonthlyData;
    console.log("data1", data);
    let percentageData = dashboardData?.activityAnalysis?.percentageDifferences;
    let dataMap = new Map();
    let others = new Array(12).fill(null).map((_, i) => ({
      month: i + 1,
      totalSpent: 0,
    }));

    const activityArr = [
      "Production Materials",
      "Finished Goods",
      "Transportation and Distribution",
      "Information Technology and Communication",
      "Professional Services",
      // "Others",
    ];
    const FIXED_CATEGORIES = [
      "Finished Goods",
      "Information Technology and Communication",
      "Production Materials",
      "Professional Services",
      "Transportation and Distribution (not included in Upstream and Downstream Transportation and Distribution category)",
    ];

    const setActivityPercentageFun = (percentageMap) => {
      const activityPercentage = new Map();

      percentageMap?.forEach(({ categoryType, percentageDifference }) => {
        if (FIXED_CATEGORIES.includes(categoryType)) {
          activityPercentage.set(categoryType, percentageDifference);
        } else {
          activityPercentage.set("Other", percentageDifference);
        }
      });

      return activityPercentage;
    };

    data &&
      data.forEach((item) => {
        if (activityArr.includes(item.categoryType)) {
          dataMap.set(item.categoryType, item);
        } else {
          item.data.forEach((month, i) => {
            if (!others[i]) {
              others[i] = { totalSpent: 0 };
            }
            others[i].totalSpent += month?.totalSpent || 0;
          });
        }
      });

    let completeData = activityArr.map(
      (category) =>
        dataMap.get(category) || {
          categoryType: category,
          data: new Array(12).fill(null).map((_, i) => ({
            month: i + 1,
            totalSpent: 0,
          })),
        }
    );

    let existingOthersEntry =
      data && data?.find((item) => item.categoryType === "Others");

    if (existingOthersEntry) {
      existingOthersEntry.data = others;
      completeData = completeData.map((item) =>
        item.categoryType === "Others" ? existingOthersEntry : item
      );
    } else if (others.some((month) => month.totalSpent > 0)) {
      completeData.push({ categoryType: "Others", data: others });
    }

    const activityPercentage = setActivityPercentageFun(percentageData);
    setActivityPercentage(activityPercentage);

    setActivitySpend(completeData);
  }, [dashboardData,selectedCompany]);

  let colorArr = [
    "#FF4444",
    "#0066E7",
    "#FFBB33",
    "#9D2DED",
    "#A6CDC6",
    "#17D451",
    "#ffa600",
    "#003f5c",
  ];

  const spentCount =
    dashboardData?.facilitySpendEmission?.data?.filter((el) =>
      el?.monthlyData?.some((month) => month?.totalSpent)
    )?.length || 0;

  const emissionCount =
    dashboardData?.facilitySpendEmission?.data?.filter((el) =>
      el?.monthlyData?.some((month) => month?.totalEmission)
    )?.length || 0;

  const facilitySpendDataset = spentCount
    ? dashboardData?.facilitySpendEmission?.data?.map((item, idx) => ({
        label: item.facilityName,
        data: item.monthlyData.map((month) => month.totalSpent),
        backgroundColor: colorArr[idx],
      }))
    : [];

  const facilityEmissionDatasetNew = emissionCount
    ? dashboardData?.facilitySpendEmission?.data?.map((item, idx) => ({
        label: item.facilityName,
        data: item.monthlyData.map((month) => month.totalEmission.toFixed(3)),
        backgroundColor: colorArr[idx],
      }))
    : [];

  console.log(spentCount, emissionCount, "check1");

  const vendorSpendDataset = {
    label: graphView?.vendorName || "Vendor Spend",
    data:
      dashboardData?.vendorSpendEmission?.data?.map(
        (item) => item.totalSpent
      ) || [],
    backgroundColor: "#FFBB33",
  };

  const vendorEmissionDatasetNew = {
    label: graphView?.vendorName || "Vendor Spend",
    data:
      dashboardData?.vendorSpendEmission?.data?.map(
        (item) => item.totalEmission
      ) || [],
    backgroundColor: "#0066E7",
  };

  const fetchVendorList = async () => {
    try {
      const res = await get(
        `/dashboard/scope3/purchasegoods/vendorlist?facilities=${selectedFacility.join(
          ","
        )}&companyId=${selectedCompany?._id}`
      );
      setVendors(res?.data?.data.map((item) => item.vendorLegalName));
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchVendorList();
  }, [selectedFacility,selectedCompany]);

  let vendorEmissionSpent = [
    {
      label: "Spending",
      data: dashboardData?.comparativeSpending?.spendEmission
        ?.filter((el) => graphView?.vendorName === el?.vendor)?.[0]
        ?.data?.map((el) => el?.totalEmission) || [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      ],
      backgroundColor: "rgba(255, 187, 51, 0.8)",
      borderColor: "rgba(255, 187, 51, 1)",
      borderWidth: 0.5,
    },
    {
      label: "Emission",
      data: dashboardData?.comparativeSpending?.spendEmission
        ?.filter((el) => graphView?.vendorName === el?.vendor)?.[0]
        ?.data?.map((el) => el?.totalSpent) || [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      ],
      backgroundColor: "rgba(0, 102, 231, 0.8)",
      borderColor: "rgba(0, 102, 231, 1)",
      borderWidth: 0.5,
    },
  ];

  let barCharDataSet = [
    {
      label: "Industry Benchmarks",
      data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      backgroundColor: "rgba(255, 187, 51, 0.8)",
      borderColor: "rgba(255, 187, 51, 1)",
      borderWidth: 0.5,
    },
    {
      label: "Our Consumption",
      data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      backgroundColor: "rgba(0, 102, 231, 0.8)",
      borderColor: "rgba(0, 102, 231, 1)",
      borderWidth: 0.5,
    },
  ];

  const emissionActivityColor = [
    { label: "Production Materials", color: "rgba(0, 102, 231, 1)" },
    { label: "Finished Goods", color: "rgba(255, 99, 132, 1)" },
    {
      label: "Transportation and Distribution",
      color: "rgba(75, 192, 192, 1)",
    },
    {
      label: "Information Technology and Communication",
      color: "rgba(255, 159, 64, 1)",
    },
    { label: "Professional Services", color: "rgba(153, 102, 255, 1)" },
    { label: "Others", color: "rgba(54, 162, 235, 1)" },
  ];

  let categoryColor = [
    { label: "Finished Goods", color: "rgba(146, 0, 183, 1)" },
    { label: "Transportation and Distribution", color: "rgba(14, 98, 224, 1)" },
    { label: "Scooter", color: "rgba(60, 215, 21, 1)" },
    { label: "Sedan", color: "rgba(255, 79, 79, 1)" },
  ];

  let emissionActivityDataset = manipulateDataForBarChart({
    data: dashboardData?.emissionActivity?.graphData,
    colors: emissionActivityColor,
    type: "purchaseEmissionData",
  });

  let vendorEmissionDataset =
    dashboardData?.vendorEmission?.graphData
      ?.map((el) => el?.totalSpent)
      ?.filter(Boolean)?.length > 0
      ? generateBarChartDataSetForWaste(
          dashboardData?.vendorEmission?.graphData,
          "rgba(0, 81, 183, 1)",
          "Vendor Emission"
        )
      : [];

  console.log(
    dashboardData?.vendorEmission?.graphData
      ?.map((el) => el?.totalSpent)
      ?.filter(Boolean)?.length,
    "check1"
  );

  let facilityEmissionDataset = generateBarChartDataSetForWaste(
    dashboardData?.facilitySpecific?.data,
    "rgba(0, 81, 183, 1)",
    "Facility Emission"
  );

  let vendorSpentDataset =
    dashboardData?.spendAnalysisVendor?.graphData
      ?.map((el) => el?.totalSpent)
      ?.filter(Boolean)?.length > 0
      ? generateBarChartDataSetForWaste(
          dashboardData?.spendAnalysisVendor?.graphData,
          "rgba(0, 102, 231, 1)",
          "Vendor Spent"
        )
      : [];

  let facilitySpentDataset = generateBarChartDataSetForWaste(
    dashboardData?.spendAnalysisFacility?.facilityGraph,
    "rgba(0, 102, 231, 1)",
    "Facility Spent"
  );

  let categorySpentDataset = manipulateDataForBarChart({
    data: dashboardData?.activityAnalysis?.spendingMonthlyData,
    colors: emissionActivityColor,
    type: "commute",
  });

  const categoryTypeDataset = manipulateDataForBarChart({
    data: activitySpend,
    colors: emissionActivityColor,
    type: "category",
  });

  const colorMapping = [
    "rgba(255, 79, 79, 1)",
    "rgba(146, 0, 183, 1)",
    "rgba(14, 98, 224, 1)",
  ];

  let topVendorSpendDataset = manipulateDataForBarChart({
    data: dashboardData?.comparativeSpending?.spendEmission,
    colors: dashboardData?.comparativeSpending?.spendEmission.map(
      (item, idx) => ({
        label: item.vendor,
        color: colorMapping[idx] || "rgba(128, 128, 128, 1)",
      })
    ),
    type: "vendorPurchase",
  });

  let topVendorEmissionDataset = manipulateDataForBarChart({
    data: dashboardData?.comparativeSpending?.spendEmission,
    colors: dashboardData?.comparativeSpending?.spendEmission.map(
      (item, idx) => ({
        label: item.vendor,
        color: colorMapping[idx] || "rgba(128, 128, 128, 1)",
      })
    ),
    type: "vendorPurchaseEmission",
  });

  let vendorSpendEmissionDataset = [
    {
      label: "Emission",
      data:
        dashboardData?.vendorSpecificSpendEmission?.emission[0]?.data?.map(
          (item) => item.totalSpent
        ) ?? [],
      borderColor: "rgba(0, 102, 231, 1)",
      backgroundColor: "rgba(0, 102, 231, 0.9)",
      tension: 0.4,
      fill: true,
      pointBorderColor: "#fff",
      pointRadius: 0,
    },
    {
      label: "Spending",
      data:
        dashboardData?.vendorSpecificSpendEmission?.spending[0]?.data?.map(
          (item) => item.totalSpent
        ) ?? [],
      borderColor: "rgba(255, 187, 51, 1)",
      backgroundColor: "rgba(255, 187, 51, 0.9)",
      tension: 0.4,
      fill: true,
      pointBorderColor: "#fff",
      pointRadius: 0,
    },
  ];

  let facilitySpendEmissionDataset = [
    {
      label: "Emission",
      data:
        dashboardData?.spendAnalysisFacility?.facilityGraph?.map((item) =>
          parseInt(item.amountSpend)
        ) ?? [],
      borderColor: "rgba(0, 102, 231, 1)",
      backgroundColor: "rgba(0, 102, 231, 0.9)",
      tension: 0.4,
      fill: true,
      pointBorderColor: "#fff",
      pointRadius: 0,
    },
    {
      label: "Spending",
      data:
        dashboardData?.facilitySpecific?.data?.map((item) =>
          parseInt(item.totalSpentValue)
        ) ?? [],
      borderColor: "rgba(255, 79, 79, 1)",
      backgroundColor: "rgba(255, 79, 79, 0.9)",
      tension: 0.4,
      fill: true,
      pointBorderColor: "#fff",
      pointRadius: 0,
    },
  ];

  const categoryColors = {
    "Production Materials": "rgba(0, 102, 231, 1)",
    "Finished Goods": "rgba(255, 99, 132, 1)",
    "Transportation and Distribution": "rgba(75, 192, 192, 1)",
    "Information Technology and Communication": "rgba(255, 159, 64, 1)",
    "Professional Services": "rgba(153, 102, 255, 1)",
    Others: "rgba(54, 162, 235, 1)",
  };

  const activityDatasets = Object.entries(categoryColors).map(
    ([category, color]) =>
      generateBarChartDataSetForWaste(
        activitySpend?.find((item) => item.categoryType === category)?.data ||
          [],
        color,
        category
      )
  );

  const [
    productionActivityDataset,
    finishedGoodsActivityDataset,
    transportActivityDataset,
    itActivityDataset,
    professionalActivityDataset,
    othersActivityDataset,
  ] = activityDatasets;

  const handleGraphChange = (e, type) => {
    if (type === "topVendor") {
      setGraphView((prev) => ({ ...prev, topVendor: e.target.value }));
    } else if (type === "vendorName") {
      setGraphView((prev) => ({ ...prev, vendorName: e.target.value }));
    } else if (type === "facilityName") {
      setGraphView((prev) => ({ ...prev, facilityName: e.target.value }));
    } else if (type === "yearData") {
      setGraphView((prev) => ({ ...prev, yearData: e.target.value }));
    } else if (type === "activityName") {
      setGraphView((prev) => ({ ...prev, activityName: e.target.value }));
    } else if (type === "facilityType") {
      setGraphView((prev) => ({ ...prev, facilityType: e.target.value }));
    }
  };
  console.log(productionActivityDataset, "c2");

  return (
    <>
      <div className={styles.heading_container}>
        <p className={styles.heading}>Purchase Goods & Services</p>
        <PeriodFilter
          {...{
            fromDate,
            setFromDate,
            toDate,
            setToDate,
            yearList,
            setSelectedFacility,
            selectedFacility,
          }}
        />
      </div>

      <div className={styles.purchase_container}>
        <p className={styles.sub_heading}>Emission Analysis</p>
        <div className={styles.card_container}>
          <p className={styles.card_heading}>
            Total Emissions from Purchases (tCO2e)
          </p>
          <p className={styles.card_value}>
            {formatNumberCommaSeparated(
              fixedTons(dashboardData?.totalAmount?.data || 0)
            )}
          </p>
        </div>
        <div className={styles.chart_container}>
          <div className={styles.graph_container_header}>
            <div>
              <p className={styles.graph_heading}>
                Emissions by Type of Activities (tCO2e)
              </p>
              <p className={styles.graph_value}>
                {formatNumberCommaSeparated(
                  fixedTons(dashboardData?.emissionActivity?.totalEmission || 0)
                )}
              </p>
            </div>
          </div>
          <BarChart
            datasets={emissionActivityDataset}
            labels={dashboardData?.emissionActivity?.graphData?.[0]?.data?.map(
              (el) =>
                monthSort[el?.month - 1] + "'" + el?.year.toString().slice(-2)
            )}
            display={true}
          />
        </div>
        <div className={styles.emission_container}>
          <div className={styles.card_container}>
            <div className={styles.graph_container_header}>
              <div>
                <p className={styles.graph_heading}>
                  Emissions by Vendor (tCO2e)
                </p>
                <p className={styles.graph_value}>
                  {formatNumberCommaSeparated(
                    fixedTons(
                      dashboardData?.vendorEmission?.totalEmissions ?? 0
                    )
                  )}{" "}
                  <span
                    className={`${styles.percentage_difference} ${
                      dashboardData?.vendorEmission?.differnece >= 0
                        ? styles.positive
                        : styles.negative
                    }`}
                  >
                    (
                    {fixedPercentage(
                      dashboardData?.vendorEmission?.differnece ?? 0
                    )}
                    % YOY)
                  </span>
                </p>
              </div>
              <div>
                <select
                  style={{ width: "150px" }}
                  name="month"
                  id="month"
                  value={graphView.vendorName}
                  onChange={(e) => handleGraphChange(e, "vendorName")}
                  className={styles.heading_select_month}
                >
                  {vendorList.map((m) => (
                    <option key={m} value={m}>
                      {m}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <BarChart
              datasets={vendorEmissionDataset}
              labels={dashboardData?.vendorEmission?.graphData?.map(
                (el) =>
                  monthSort[el?.month - 1] + "'" + el?.year.toString().slice(-2)
              )}
            />
          </div>
          <div className={styles.card_container}>
            <div className={styles.graph_container_header}>
              <div>
                <p className={styles.graph_heading}>
                  Emissions by Facility (tCO2e)
                </p>
                <p className={styles.graph_value}>
                  {formatNumberCommaSeparated(
                    fixedTons(
                      dashboardData?.facilitySpecific?.totalEmissionSum ?? 0
                    )
                  )}{" "}
                  <span
                    className={`${styles.percentage_difference} ${
                      dashboardData?.facilitySpecific?.differnece >= 0
                        ? styles.positive
                        : styles.negative
                    }`}
                  >
                    (
                    {fixedPercentage(
                      dashboardData?.facilitySpecific?.differnece ?? 0
                    )}
                    % YOY)
                  </span>
                </p>
              </div>
            </div>
            <BarChart
              datasets={facilityEmissionDataset}
              labels={dashboardData?.facilitySpecific?.data.map((item) => {
                return item.facility;
              })}
            />
          </div>
        </div>

        <div className={styles.card_container_map}>
          <div className={styles.world_map_header_container}>
            <p className={styles.graph_heading}>Total Emissions by Country</p>
            <div className={styles.input_date_loc_select_container}>
              <select
                name="month"
                id="month"
                value={month}
                onChange={(e) => setMonth(e.target.value)}
                className={styles.heading_select_month}
              >
                {durationObj?.map((m) => (
                  <option key={m?.id} value={m?.id}>
                    {m?.label}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className={styles.global_travel_container}>
            <div className={styles.global_travel_table}>
              <TableChart tableData={tableData} />
            </div>
            <div className={styles.global_travel_graph}>
              <GlobalChart tableData={tableData} />
            </div>
          </div>
        </div>
      </div>

      <div className={styles.purchase_container}>
        <p className={styles.sub_heading}>Spending Analysis</p>
        <div className={styles.card_container}>
          <p className={styles.card_heading}>Total Amount Spent (USD)</p>
          <p className={styles.card_value}>
            {formatNumberCommaSeparated(
              fixedTons(
                dashboardData?.spendAnalysisAmount?.data[0]?.totalSpent ?? 0
              )
            )}
          </p>
        </div>
        <div className={styles.chart_container}>
          <div className={styles.graph_container_header}>
            <div>
              <p className={styles.graph_heading}>
                Total Amount Spent in Various Activities (USD)
              </p>
              <p className={styles.graph_value}>
                {formatNumberCommaSeparated(
                  fixedTons(dashboardData?.spendAnalysisActivity?.amount ?? 0)
                )}
              </p>
            </div>
          </div>
          <BarChart
            datasets={categorySpentDataset}
            labels={dashboardData?.activityAnalysis?.spendingMonthlyData?.[0]?.data?.map(
              (el) =>
                monthSort[el?.month - 1] + "'" + el?.year.toString().slice(-2)
            )}
            display={true}
          />
        </div>
        <div className={styles.emission_container}>
          <div className={styles.card_container}>
            <div className={styles.graph_container_header}>
              <div>
                <p className={styles.graph_heading}>
                  Amount Spend by Vendors (USD)
                </p>
                <p className={styles.graph_value}>
                  {formatNumberCommaSeparated(
                    fixedTons(
                      dashboardData?.spendAnalysisVendor
                        ?.totalCurrentYearSpent ?? 0
                    )
                  )}{" "}
                  <span
                    className={`${styles.percentage_difference} ${
                      dashboardData?.spendAnalysisVendor?.differnece >= 0
                        ? styles.positive
                        : styles.negative
                    }`}
                  >
                    (
                    {fixedPercentage(
                      dashboardData?.spendAnalysisVendor?.differnece ?? 0,
                      2
                    )}
                    % YOY)
                  </span>
                </p>
              </div>
              <select
                style={{ width: "150px" }}
                name="month"
                id="month"
                value={graphView.vendorName}
                onChange={(e) => handleGraphChange(e, "vendorName")}
                className={styles.heading_select_month}
              >
                {vendorList.map((m) => (
                  <option key={m} value={m}>
                    {m}
                  </option>
                ))}
              </select>
            </div>
            <BarChart
              datasets={vendorSpentDataset}
              labels={dashboardData?.spendAnalysisVendor?.graphData?.map(
                (el) =>
                  monthSort[el?.month - 1] + "'" + el?.year.toString().slice(-2)
              )}
              display={true}
            />
          </div>
          <div className={styles.card_container}>
            <div className={styles.graph_container_header}>
              <div>
                <p className={styles.graph_heading}>
                  Amount Spent by Facilities (USD)
                </p>
                <p className={styles.graph_value}>
                  {formatNumberCommaSeparated(
                    fixedTons(
                      dashboardData?.spendAnalysisFacility
                        ?.totalCurrentYearSpent ?? 0
                    )
                  )}{" "}
                  <span
                    className={`${styles.percentage_difference} ${
                      dashboardData?.spendAnalysisFacility?.differnece >= 0
                        ? styles.positive
                        : styles.negative
                    }`}
                  >
                    (
                    {fixedPercentage(
                      dashboardData?.spendAnalysisFacility?.differnece ?? 0
                    )}
                    % YOY)
                  </span>
                </p>
              </div>
            </div>
            <BarChart
              datasets={facilitySpentDataset}
              labels={dashboardData?.spendAnalysisFacility?.facilityGraph.map(
                (item) => {
                  return item.facility;
                }
              )}
              display={true}
            />
          </div>
        </div>
        <div className={styles.card_container_map}>
          <div className={styles.world_map_header_container}>
            <p className={styles.graph_heading}>
              Total Amount spent by Country
            </p>
            <div className={styles.input_date_loc_select_container}>
              <select
                name="month"
                id="month"
                value={countryEmissionMonth}
                onChange={(e) => setCountryEmissionMonth(e.target.value)}
                className={styles.heading_select_month}
              >
                {durationObj?.map((m) => (
                  <option key={m?.id} value={m?.id}>
                    {m?.label}
                  </option>
                ))}
              </select>

              {/* <select
                name="year"
                id="year"
                value={year}
                onChange={(e) => setYear(e.target.value)}
                className={styles.heading_select_year}
              >
                {["World"].map((y) => (
                  <option key={y} value={y}>
                    {y}
                  </option>
                ))}
              </select> */}
            </div>
          </div>

          <div className={styles.global_travel_container}>
            <div className={styles.global_travel_table}>
              <TableChartAmount tableData={amountSpent} />
            </div>
            <div className={styles.global_travel_graph}>
              <GlobalChart tableData={amountSpent} />
            </div>
          </div>
        </div>
        <div className={styles.chart_container}>
          <div className={styles.graph_container_header}>
            <div>
              <p className={styles.graph_heading}>
                Spending by Category Type (USD)
              </p>
              <p className={styles.graph_value}>
                {formatNumberCommaSeparated(
                  fixedTons(dashboardData?.activityAnalysis?.totalSpentSum ?? 0)
                )}{" "}
                <span
                  className={`${styles.percentage_difference} ${
                    dashboardData?.spendAnalysisVendor?.differnece >= 0
                      ? styles.positive
                      : styles.negative
                  }`}
                >
                  (
                  {fixedPercentage(
                    dashboardData?.spendAnalysisVendor?.differnece ?? 0
                  )}
                  % YOY)
                </span>
              </p>
            </div>
            {/* <div>
              <select
                style={{ width: "200px" }}
                name="month"
                id="month"
                value={graphView.activityName}
                onChange={(e) => handleGraphChange(e, "activityName")}
                className={styles.heading_select_month}
              >
                {activityArr.map((m) => (
                  <option key={m} value={m}>
                    {m}
                  </option>
                ))}
              </select>
            </div> */}
          </div>
          <BarChart
            datasets={categoryTypeDataset}
            labels={dashboardData?.activityAnalysis?.spendingMonthlyData?.[0]?.data?.map(
              (el) =>
                monthSort[el?.month - 1] + "'" + el?.year.toString().slice(-2)
            )}
            display={true}
          />
        </div>
      </div>

      <div className={styles.purchase_container}>
        <p className={styles.sub_heading}>Activity-Specific Analysis</p>
        <div className={styles.emission_container}>
          <div className={styles.card_container}>
            <div className={styles.graph_container_header}>
              <div>
                <p className={styles.graph_heading}>
                  Production materials (USD)
                </p>
                <p className={styles.graph_value}>
                  {formatNumberCommaSeparated(
                    fixedTons(
                      activitySpend
                        ?.find(
                          (item) => item.categoryType === "Production Materials"
                        )
                        ?.data.reduce(
                          (sum, { totalSpent }) => sum + totalSpent,
                          0
                        ) ?? 0
                    )
                  )}{" "}
                  <span
                    className={`${styles.percentage_difference} ${
                      activityPercetage?.get("Production Materials") >= 0
                        ? styles.positive
                        : styles.negative
                    }`}
                  >
                    {/* ({dashboardData?.spendAnalysisVendor?.differnece ?? 0}% YOY) */}
                    ({activityPercetage?.get("Production Materials") ?? 0}% YOY)
                  </span>
                </p>
              </div>
            </div>
            <BarChart
              datasets={
                productionActivityDataset?.[0]?.length > 0
                  ? productionActivityDataset
                  : []
              }
              labels={dashboardData?.activityAnalysis?.spendingMonthlyData?.[0]?.data?.map(
                (el) =>
                  monthSort[el?.month - 1] + "'" + el?.year.toString().slice(-2)
              )}
              display={true}
            />
          </div>
          <div className={styles.card_container}>
            <div className={styles.graph_container_header}>
              <div>
                <p className={styles.graph_heading}>Finished Goods (USD)</p>
                <p className={styles.graph_value}>
                  {formatNumberCommaSeparated(
                    fixedTons(
                      activitySpend
                        ?.find((item) => item.categoryType === "Finished Goods")
                        ?.data.reduce(
                          (sum, { totalSpent }) => sum + totalSpent,
                          0
                        ) ?? 0
                    )
                  )}{" "}
                  <span
                    className={`${styles.percentage_difference} ${
                      activityPercetage?.get("Finished Goods") >= 0
                        ? styles.positive
                        : styles.negative
                    }`}
                  >
                    (
                    {fixedPercentage(
                      activityPercetage?.get("Finished Goods") ?? 0
                    )}
                    % YOY)
                  </span>
                </p>
              </div>
            </div>
            <BarChart
              datasets={
                finishedGoodsActivityDataset?.[0]?.data?.length > 0
                  ? finishedGoodsActivityDataset
                  : []
              }
              labels={dashboardData?.activityAnalysis?.spendingMonthlyData?.[0]?.data?.map(
                (el) =>
                  monthSort[el?.month - 1] + "'" + el?.year.toString().slice(-2)
              )}
              display={true}
            />
          </div>
        </div>
        <div className={styles.emission_container}>
          <div className={styles.card_container}>
            <div className={styles.graph_container_header}>
              <div>
                <p className={styles.graph_heading}>
                  Transportation and Distribution (USD)
                </p>
                <p className={styles.graph_value}>
                  {formatNumberCommaSeparated(
                    fixedTons(
                      activitySpend
                        ?.find(
                          (item) =>
                            item.categoryType ===
                            "Transportation and Distribution"
                        )
                        ?.data.reduce(
                          (sum, { totalSpent }) => sum + totalSpent,
                          0
                        ) ?? 0
                    )
                  )}{" "}
                  <span
                    className={`${styles.percentage_difference} ${
                      activityPercetage?.get(
                        "Transportation and Distribution (not included in Upstream and Downstream Transportation and Distribution category)"
                      ) >= 0
                        ? styles.positive
                        : styles.negative
                    }`}
                  >
                    (
                    {fixedPercentage(
                      activityPercetage?.get(
                        "Transportation and Distribution (not included in Upstream and Downstream Transportation and Distribution category)"
                      ) ?? 0
                    )}
                    % YOY)
                  </span>
                </p>
              </div>
            </div>
            <BarChart
              datasets={
                transportActivityDataset?.[0]?.data?.length > 0
                  ? transportActivityDataset
                  : []
              }
              labels={dashboardData?.activityAnalysis?.spendingMonthlyData?.[0]?.data?.map(
                (el) =>
                  monthSort[el?.month - 1] + "'" + el?.year.toString().slice(-2)
              )}
              display={true}
            />
          </div>
          <div className={styles.card_container}>
            <div className={styles.graph_container_header}>
              <div>
                <p className={styles.graph_heading}>
                  Information Technology and Communication (USD)
                </p>
                <p className={styles.graph_value}>
                  {formatNumberCommaSeparated(
                    fixedTons(
                      activitySpend
                        ?.find(
                          (item) =>
                            item.categoryType ===
                            "Information Technology and Communication"
                        )
                        ?.data.reduce(
                          (sum, { totalSpent }) => sum + totalSpent,
                          0
                        ) ?? 0
                    )
                  )}{" "}
                  <span
                    className={`${styles.percentage_difference} ${
                      activityPercetage?.get(
                        "Information Technology and Communication"
                      ) >= 0
                        ? styles.positive
                        : styles.negative
                    }`}
                  >
                    (
                    {fixedPercentage(
                      activityPercetage?.get(
                        "Information Technology and Communication"
                      ) ?? 0
                    )}
                    % YOY)
                  </span>
                </p>
              </div>
            </div>
            <BarChart
              datasets={
                itActivityDataset?.[0]?.data?.length > 0
                  ? itActivityDataset
                  : []
              }
              labels={dashboardData?.activityAnalysis?.spendingMonthlyData?.[0]?.data?.map(
                (el) =>
                  monthSort[el?.month - 1] + "'" + el?.year.toString().slice(-2)
              )}
              display={true}
            />
          </div>
        </div>
        <div className={styles.emission_container}>
          <div className={styles.card_container}>
            <div className={styles.graph_container_header}>
              <div>
                <p className={styles.graph_heading}>Others (USD)</p>
                <p className={styles.graph_value}>
                  {formatNumberCommaSeparated(
                    fixedTons(
                      activitySpend
                        ?.find((item) => item.categoryType === "Others")
                        ?.data.reduce(
                          (sum, { totalSpent }) => sum + totalSpent,
                          0
                        ) ?? 0
                    )
                  )}{" "}
                  <span
                    className={`${styles.percentage_difference} ${
                      dashboardData?.spendAnalysisVendor?.differnece >= 0
                        ? styles.positive
                        : styles.negative
                    }`}
                  >
                    ({fixedPercentage(activityPercetage?.get("Other") ?? 0)}%
                    YOY)
                  </span>
                </p>
              </div>
            </div>
            <BarChart
              datasets={
                othersActivityDataset?.[0]?.data?.length > 0
                  ? othersActivityDataset
                  : []
              }
              labels={dashboardData?.activityAnalysis?.spendingMonthlyData?.[0]?.data?.map(
                (el) =>
                  monthSort[el?.month - 1] + "'" + el?.year.toString().slice(-2)
              )}
              display={true}
            />
          </div>
          <div className={styles.card_container}>
            <div className={styles.graph_container_header}>
              <div>
                <p className={styles.graph_heading}>
                  Spending and emissions from professional services (USD)
                </p>
                <p className={styles.graph_value}>
                  {formatNumberCommaSeparated(
                    fixedTons(
                      activitySpend
                        ?.find(
                          (item) =>
                            item.categoryType === "Professional Services"
                        )
                        ?.data.reduce(
                          (sum, { totalSpent }) => sum + totalSpent,
                          0
                        ) ?? 0
                    )
                  )}{" "}
                  <span
                    className={`${styles.percentage_difference} ${
                      activityPercetage?.get("Professional Services") >= 0
                        ? styles.positive
                        : styles.negative
                    }`}
                  >
                    (
                    {fixedPercentage(
                      activityPercetage?.get("Professional Services") ?? 0
                    )}
                    % YOY)
                  </span>
                </p>
              </div>
            </div>
            <BarChart
              datasets={
                professionalActivityDataset?.[0]?.data?.length > 0
                  ? professionalActivityDataset
                  : []
              }
              labels={dashboardData?.activityAnalysis?.spendingMonthlyData?.[0]?.data?.map(
                (el) =>
                  monthSort[el?.month - 1] + "'" + el?.year.toString().slice(-2)
              )}
              display={true}
            />
          </div>
        </div>
      </div>

      <div className={styles.purchase_container}>
        <p className={styles.sub_heading}>Vendor Analysis</p>
        <div className={styles.chart_container}>
          <div className={styles.graph_container_header}>
            <div>
              <p className={styles.graph_heading}>
                Top Vendors by Spend and Emissions
              </p>
            </div>
            <div>
              <select
                name="month"
                id="month"
                value={graphView.topVendor}
                onChange={(e) => handleGraphChange(e, "topVendor")}
                className={styles.heading_select_month}
              >
                {["Spending", "Emission"].map((m) => (
                  <option key={m} value={m}>
                    {m}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <BarChart
            datasets={
              graphView?.topVendor === "Spending"
                ? topVendorSpendDataset
                : topVendorEmissionDataset
            }
            labels={dashboardData?.comparativeSpending?.spendEmission?.[0]?.data?.map(
              (el) =>
                monthSort[el?.month - 1] + "'" + el?.year.toString().slice(-2)
            )}
            display={true}
          />
        </div>
        <div className={styles.chart_container}>
          <div className={styles.graph_container_header}>
            <div>
              <p className={styles.graph_heading}>
                Comparative analysis of spending & emissions among vendors.
              </p>
              <p className={styles.graph_value}>
                {formatNumberCommaSeparated(
                  fixedTons(
                    dashboardData?.comparativeSpending?.totalEmission ?? 0
                  )
                )}{" "}
                <span
                  className={`${styles.percentage_difference} ${
                    dashboardData?.comparativeSpending?.percentageDifference >=
                    0
                      ? styles.positive
                      : styles.negative
                  }`}
                >
                  (
                  {fixedPercentage(
                    dashboardData?.comparativeSpending?.percentageDifference ??
                      0
                  )}
                  % YOY)
                </span>
              </p>
            </div>
            <div>
              <select
                name="month"
                id="month"
                value={graphView.vendorName}
                onChange={(e) => handleGraphChange(e, "vendorName")}
                className={styles.heading_select_month}
              >
                {vendorList.map((m) => (
                  <option key={m} value={m}>
                    {m}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <BarChart
            datasets={vendorEmissionSpent}
            labels={dashboardData?.comparativeSpending?.spendEmission?.[0]?.data?.map(
              (el) =>
                monthSort[el?.month - 1] + "'" + el?.year.toString().slice(-2)
            )}
            display={true}
          />
        </div>

        {/* <div className={styles.card_container_map}>
          <div className={styles.world_map_header_container}>
            <p className={styles.graph_heading}>Vendor Comparison</p>
            <div className={styles.input_date_loc_select_container}>
              <select
                name="month"
                id="month"
                value={month}
                onChange={(e) => setMonth(e.target.value)}
                className={styles.heading_select_month}
              >
                {["Current Month", "Last 6 Month", "Last 12 Months"].map((m) => (
                  <option key={m} value={m}>
                    {m}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className={styles.global_travel_container}>
            <div className={styles.global_travel_table}>
              <TableChart />
            </div>
            <div className={styles.global_travel_graph}>
              <GlobalChart />
            </div>
          </div>
        </div> */}
      </div>

      <div className={styles.purchase_container}>
        <p className={styles.sub_heading}>Facility-Specific Analysis</p>
        <div className={styles.chart_container}>
          <div className={styles.graph_container_header}>
            <div>
              <p className={styles.graph_heading}>
                Spending and Emissions per Facility
              </p>
            </div>
          </div>
          <BarChart
            datasets={facilitySpendEmissionDataset}
            labels={dashboardData?.facilitySpecific?.data?.map(
              (item) => item.facility
            )}
            display={true}
          />
        </div>
        <div className={styles.chart_container}>
          <div className={styles.graph_container_header}>
            <div>
              <p className={styles.graph_heading}>
                Spending and Emissions per Facility (
                {graphView?.facilityType === "Spending" ? "USD" : "tCO2e"})
              </p>
              <p className={styles.graph_value}>
                {graphView?.facilityType === "Spending"
                  ? `${formatNumberCommaSeparated(
                      fixedTons(
                        facilitySpendDataset?.reduce(
                          (sum, item) =>
                            sum + item.data.reduce((a, b) => a + b, 0),
                          0
                        )
                      )
                    )} `
                  : `${fixedTons(
                      facilityEmissionDatasetNew?.reduce(
                        (sum, item) =>
                          sum +
                          item.data.reduce((a, b) => a + parseFloat(b), 0),
                        0
                      )
                    )}`}
                <span
                  className={`${styles.percentage_difference} ${
                    dashboardData?.spendAnalysisVendor?.differnece >= 0
                      ? styles.positive
                      : styles.negative
                  }`}
                >
                  {" "}
                  (
                  {fixedPercentage(
                    dashboardData?.spendAnalysisVendor?.differnece ?? 0
                  )}
                  % YOY)
                </span>
              </p>
            </div>
            <div>
              <select
                name="month"
                id="month"
                value={graphView.facilityType}
                onChange={(e) => handleGraphChange(e, "facilityType")}
                className={styles.heading_select_month}
              >
                {["Spending", "Emission"]?.map((m) => (
                  <option key={m} value={m}>
                    {m}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <BarChart
            datasets={
              graphView?.facilityType === "Spending"
                ? facilitySpendDataset
                : graphView?.facilityType === "Emission"
                ? facilityEmissionDatasetNew
                : barCharDataSet
            }
            labels={dashboardData?.facilitySpendEmission?.data?.[0]?.monthlyData?.map(
              (el) =>
                monthSort[el?.month - 1] + "'" + el?.year.toString().slice(-2)
            )}
            display={true}
          />
        </div>
      </div>

      <div className={styles.purchase_container}>
        {/* <p className={styles.sub_heading}>Goods and Services Analysis</p>
        <div className={styles.chart_container}>
          <div className={styles.graph_container_header}>
            <div>
              <p className={styles.graph_heading}>
                Spending on Different Goods/Services
              </p>
              <p className={styles.graph_value}>
                Rs {dashboardData?.spendAnalysisVendor?.totalCurrentYearSpent}
              </p>
            </div>
          </div>
          <BarChart
            datasets={barCharDataSet}
            labels={monthSort}
            display={true}
          />
        </div>
        <div className={styles.chart_container}>
          <div className={styles.graph_container_header}>
            <div>
              <p className={styles.graph_heading}>
                Emissions from Different Goods/Services
              </p>
              <p className={styles.graph_value}>
                {dashboardData?.spendAnalysisVendor?.totalCurrentYearSpent ?? 0}{" "}
                Tonnes
              </p>
            </div>
          </div>
          <BarChart
            datasets={barCharDataSet}
            labels={monthSort}
            display={true}
          />
        </div> */}

        <div className={styles.chart_container}>
          <div className={styles.graph_container_header}>
            <div>
              <p className={styles.graph_heading}>
                Top Purchased Goods/Services
              </p>
            </div>
            <div>
              <select
                name="month"
                id="month"
                value={graphView.yearData}
                onChange={(e) => handleGraphChange(e, "yearData")}
                className={styles.heading_select_month}
              >
                {yearList.map((m) => (
                  <option key={m} value={m}>
                    {m}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className={styles.top_purchased_goods_container}>
            <div>
              <p className={styles.table_heading}>Based on Spending (USD)</p>
              <div>
                {dashboardData?.topPurchasedGoods?.basedOnSpending
                  .map((el) => el?.totalSpent)
                  ?.filter(Boolean)?.length > 0 ? (
                  dashboardData?.topPurchasedGoods?.basedOnSpending.map(
                    (item, idx) => (
                      <div key={item._id} className={styles.data_table}>
                        <p className={styles.table_sub_heading}>
                          {idx + 1}. {item._id}
                        </p>
                        <p className={styles.table_sub_value}>
                          {formatNumberCommaSeparated(
                            fixedTons(item?.totalSpent)
                          )}
                        </p>
                      </div>
                    )
                  )
                ) : (
                  <Box sx={{ my: "2rem" }}>
                    <NoDataFound />
                  </Box>
                )}
              </div>
            </div>
            <div>
              <p className={styles.table_heading}>Based on Emission (tCO2e)</p>
              <div>
                {dashboardData?.topPurchasedGoods?.basedOnEmission
                  .map((el) => el?.totalSpent)
                  ?.filter(Boolean)?.length > 0 ? (
                  dashboardData?.topPurchasedGoods?.basedOnEmission.map(
                    (item, idx) => (
                      <div key={item._id} className={styles.data_table}>
                        <p className={styles.table_sub_heading}>
                          {idx + 1}. {item._id}
                        </p>
                        <p className={styles.table_sub_value}>
                          {formatNumberCommaSeparated(
                            fixedTons(item?.totalSpent)
                          )}
                        </p>
                      </div>
                    )
                  )
                ) : (
                  <Box sx={{ my: "2rem" }}>
                    <NoDataFound />
                  </Box>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
